<template>
  <div>
    <div>
      <img
        class="mainBackImg"
        :src="
          language === 'zh'
            ? require('@/assets/images/pilotService/questionnaireInvestigationBackImg.jpg')
            : require('@/assets/images/pilotService/en_questionnaireInvestigationBackImg.jpg')
        "
      />
    </div>
    <div class="bread">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="20" :md="18" :lg="18" :xl="16">
          <slot name="breadcrumb"></slot>
        </el-col>
      </el-row>
    </div>
    <div class="container">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="20" :md="18">
          <div
            class="contentBox"
            :class="{ isAnswer: item.isAnswer != 0 }"
            v-for="item in tableData"
            :key="item.id"
          >
            <div class="left">
              <div class="title">
                <img
                  class="logo"
                  :src="
                    item.isAnswer == 0
                      ? require('@/assets/images/pilotService/joinQuestion.png')
                      : require('@/assets/images/pilotService/doQuestion.png')
                  "
                />
                {{ item.title }}
              </div>
              <div class="remark">
                {{ item.remark }}
              </div>
            </div>
            <div class="right">
              <el-button
                plain
                round
                :disabled="item.isAnswer == 0 ? false : true"
                :type="item.isAnswer == 0 ? 'primary' : 'info'"
                size="small"
                style="width: 70px"
                @click="join(item.id)"
                >{{ item.isAnswer == 0 ? "参与" : "已完成" }}</el-button
              >
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getAnswerList } from "@/api/pilotService/questionnaireInvestigation";
import { localStorage } from "../../../utils/storage";
export default {
  data() {
    return {
      language: localStorage.getItem("language") || "zh",
      tableData: [],
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      getAnswerList()
        .then((res) => {
          if (res.code === 0) {
            this.tableData = res.data;
          }
        })
        .catch((err) => {});
    },
    join(id) {
      this.$router.push(`/pilotService/questionnaireInvestigation/${id}`);
    },
  },
};
</script>

<style scoped>
.bread {
  background-color: #f6f6f6;
  padding: 15px 20px;
}
.mainBackImg {
  width: 100%;
  /* height: 300px; */
}
.container {
  padding: 20px;
  position: relative;
}
.container::before {
  content: "";
  background-image: url("~@/assets/images/pilotService/serve_bag.jpg");
  background-size: 100% 122%;
  width: 96vw;
  height: 41vh;
  position: absolute;
  bottom: 0;
  opacity: 0.4;
  z-index: -1;
}
.contentBox {
  margin: 17px 0;
  /* padding: 3%; */
  padding: 10px 11px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 20%);
}
.isAnswer {
  color: #97989d !important;
}
.left {
  display: inherit;
  align-items: center;
  flex-grow: 1;
}
.logo {
  width: 20px;
  margin-top: 2px;
  margin-right: 8px;
}
.title {
  display: flex;
  align-items: flex-start;
  flex-grow: 0.02;
  font-weight: 800;
  font-size: 16px;
  margin-right: 10px;
}
.remark {
  flex-grow: 1;
  color: #97989d;
  font-size: 12px;
  /* width: 80%; */
}
@media only screen and (max-width: 768px) {
  .contentBox {
    align-items: flex-start;
  }
  .left {
    display: inline-block;
  }
  .title {
    font-size: 15px;
  }
  .remark {
    margin-top: 15px;
    width: calc(100% + 46px);
    font-size: 13px;
  }
  .right .el-button--small,
  .el-button--small.is-round {
    padding: 5px 10px;
  }
}
</style>